const { ToggleControl } = wp.components;

const CarPager = props => {
	
	const { attributes, setAttributes } = props;
	
	return (
		<p>
			<ToggleControl
			    label={ "Enable Pager" }
			    checked={ attributes.pager }
			    onChange={ (pagerVal) => setAttributes({pager: pagerVal} ) }
			/>
		</p>
	)
}

export default CarPager;
;